import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { Routes as AppRoutes } from "@/constants/routes";

const useCookiebotLoader = () => {
    const location = useLocation();

    useEffect(() => {
        const isFunnelFox = location.pathname.includes(AppRoutes.FFPaywall);
        const existingScript = document.getElementById("Cookiebot");

        if (isFunnelFox || existingScript) return;

        const script = document.createElement("script");
        script.id = "Cookiebot";
        script.src = "https://consent.cookiebot.com/uc.js";
        script.type = "text/javascript";
        script.setAttribute("data-cbid", "81de891c-da7d-455c-9a8e-b23366d7f42d");
        script.setAttribute(
            "data-georegions",
            "{'region':'AL, AD, AT, BY, BE, BA, BG, HR, CY, CZ, DK, EE, FI, FR, DE, GR, HU, IS, IE, IT, LV, LI, LT, LU, MT, MD, MC, ME, NL, MK, NO, PL, PT, RO, RU, SM, RS, SK, SI, ES, SE, CH, TR, UA, GB, VA','cbid':'7cbb5b81-52fc-4a05-855a-b5975269579d'}"
        );

        document.body.appendChild(script);
    }, [location.pathname]);
};

export default useCookiebotLoader;
